module.exports = __webpack_public_path__ + "static/img/img-home-co-17.f513cff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-home-co-17.png
// module id = 0lrs
// module chunks = 1